import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { BannerProvider } from './context/banner-context';
import { BannerComponent } from './banner-component';

export function BannerFactory() {
    return (
        <BaseLayoutFactory>
            <BannerProvider>
                <BannerComponent />
            </BannerProvider>
        </BaseLayoutFactory>
    );
}
